<script>
    import EntityFormInput from "../entity-form/EntityFormInput.svelte";
    import {
        createEntity,
        deleteEntity,
        getEntitiesAdmin,
        getEntityAdmin,
        updateEntity,
        getSchemas,
    } from "../../../api-client";
    import { push, replace } from "svelte-spa-router";
    import { fade } from "svelte/transition";
    import AttentionMark from "../ui/AttentionMark.svelte";
    import {
        findTranslation,
        isTranslationMissing,
    } from "../util/findMissingTranslation";
    import toast from "svelte-french-toast";
    import AuthGuard from "../../../common/AuthGuard.svelte";

    function parseEntity(schema, entity) {
        schema.fields.forEach((field) => {
            if (field.input === "Datefield" && entity[field.name]) {
                entity[field.name] = entity[field.name].replace(/Z$/, "");
            }
        });
        return entity;
    }

    export let params = {};
    $: schemaName = params.schemaName;
    $: schema = getSchemas().then((data) =>
        data.find((s) => s.name === schemaName)
    );
    $: entityId = params.id;
    $: isEdit = !!entityId && entityId !== "add";
    $: entity = isEdit
        ? getEntityAdmin(schemaName, entityId).then((value) => {
              schema.then((schema) => {
                  valueMap = parseEntity(schema, value);
              });
              //valueMap = parseEntity(schema, value);
          })
        : {};

    $: allEntities = getEntitiesAdmin(schemaName);

    let valueMap = null;

    let schemaCache = null;

    $: schema.then((schema) => {
        if (schema) {
            schemaCache = schema;
            if (valueMap == null) {
                valueMap = {};
                schema.fields.forEach((field) => {
                    if (field.input == "Htmlfield") {
                        valueMap[field.name] = "";
                    } else valueMap[field.name] = null;
                });
            }
        }
    });

    let submissionError = false;

    async function createOrUpdateEntity() {
        let promise = null;

        // look for foreign keys and replave them with ids
        if (!validateFields()) {
            submissionError = true;
            toast.error("Füllen Sie bitte alle Pflichtfelder aus");
            return;
        }

        console.log("valueMap before sending: " + JSON.stringify(valueMap));
        Object.keys(valueMap).forEach((key) => {
            if (valueMap[key] && valueMap[key].id) {
                valueMap[key] = valueMap[key].id;
            }
        });

        if (isEdit) {
            promise = updateEntity(schemaName, valueMap)
                .then(() => displaySuccess())
                .catch(() => toast.error("Fehler beim Updaten"));
        } else {
            valueMap;
            promise = createEntity(schemaName, valueMap)
                .then(() => displaySuccess())
                .catch((error) => {
                    console.log("Error", error);
                    toast.error("Fehler beim Speichern");
                });
            promise.then(() => push("/admin/entities/" + schemaName));
        }
    }

    function displaySuccess() {
        toast.success("Erfolgreich gespeichert");
        submissionError = false;
    }

    function deleteEntityAndNav() {
        if (isEdit) {
            deleteEntity(schemaName, entityId).then(() => {
                push("/admin/entities/" + schemaName);
            });
        }
    }

    function validateFields() {
        if (schemaCache) {
            return schemaCache.fields.reduce((isValid, field) => {
                if (
                    (field.input == "Checkbox" &&
                        field.required &&
                        valueMap[field.name] === null) ||
                    valueMap[field.name] === undefined
                ) {
                    valueMap[field.name] = false;
                }

                if (!isValid) {
                    return false;
                }
                if (
                    field.required &&
                    isTranslationField(valueMap[field.name])
                ) {
                    return !isTranslationMissing(valueMap[field.name]);
                }
                if (
                    field.required &&
                    !valueMap[field.name] &&
                    typeof valueMap[field.name] !== "boolean"
                ) {
                    return false;
                }
                return true;
            }, true);
        } else {
            return false;
        }
    }

    function isTranslationField(valueMapField) {
        let isTranslationField = false;
        if (!(valueMapField instanceof Object)) return false;
        Object.keys(valueMapField).forEach((key) => {
            if (key === "en" || key === "de" || key === "fr") {
                isTranslationField = true;
            }
        });
        return isTranslationField;
    }
</script>

<AuthGuard />

<div in:fade={{ duration: 500 }} style="min-height:100%; display: flex;">
    {#await allEntities then entities}
        <div
            style="display: flex; flex-direction: column; background: var(--black-100); color: white; padding: 24px"
        >
            <div
                style="margin-bottom: 24px; cursor: pointer"
                on:click={() => push("/admin/entities/" + schemaName)}
            >
                Zurück
            </div>
            {#await schema then schema}
                {#each entities as entity}
                    <div
                        class:highlighted={entity.id == entityId}
                        on:click={() =>
                            replace(
                                "/admin/entities/" +
                                    schemaName +
                                    "/" +
                                    entity.id
                            )}
                        style="cursor: pointer; margin-bottom: 16px;display: flex"
                    >
                        {findTranslation(entity, schema.nameProperty)}
                    </div>
                {/each}
            {/await}
        </div>
    {/await}
    <div style="padding: 64px">
        <!--<div style="margin-bottom: 64px">{JSON.stringify(valueMap)}</div> -->
        <div style="display: flex; flex-direction: column">
            {#await schema then schema}
                {#each schema.fields as field}
                    <div style="margin-bottom: 16px">
                        <EntityFormInput
                            fieldLabel={field.label}
                            formField={field.input}
                            value={valueMap[field.name]}
                            name={field.name}
                            required={field.required ?? false}
                            selectionSchema={field.schema}
                            translatable={field.translatable}
                            on:change={(val) =>
                                (valueMap[field.name] = val.detail)}
                        />
                    </div>
                {/each}
            {/await}
        </div>
        {#if submissionError}
            <div style="color: red; margin-top: 16px; margin-bottom: 16px">
                Bitte füllen Sie alle Pflichtfelder & Übersetzungen aus.
            </div>
        {/if}
        <div
            class="headline-s"
            on:click={() => createOrUpdateEntity()}
            style="display:flex; justify-content:center; width:526px;cursor:pointer; align-items:center;background:
        var(--black-100); color: var(--white-100); padding: 24px 0;"
        >
            Speichern
        </div>
        {#if isEdit}
            <div
                class="headline-s"
                style="display:flex; justify-content:center; width:526px;cursor:pointer; align-items:center;background:
        var(--fb-red); color: var(--white-100); padding: 24px 0; margin-top:24px"
                on:click={() => deleteEntityAndNav()}
            >
                Löschen
            </div>
        {/if}
    </div>
</div>

<style>
    .highlighted {
        color: var(--white-64);
        /* font-weight: bold; */
    }
</style>
